export default "__VITE_ASSET__710134a6__"